/* El nombre de un país, en el idioma de la interfaz.
 *
 * ⚠️  VIVE ACÁ Y NO EN `i18n.js`, Y NO ES ESTÉTICA.
 *
 * El extractor de claves de `test_i18n` SALTEA `i18n.js` a propósito
 * —es la maquinaria, no una pantalla— así que un `t()` escrito ahí
 * adentro queda sin ningún guardián: sus claves no se exigen y, si
 * sobran, tampoco se detectan. La primera versión de esto estaba en
 * i18n.js y `test_i18n` §6c marcó las tres claves como huérfanas.
 *
 * Un módulo de dominio aparte —como ya son `fechas.js` y `tintes.js`—
 * sí lo mira el extractor. */
import { t, idiomaActual } from "./i18n";

/* ══════════════════════════════════════════════════════════════════
   EL NOMBRE DE UN PAÍS, SIN TABLA DE TRADUCCIÓN
   ══════════════════════════════════════════════════════════════════

   Los 33 países del perfil llegaban del servidor en español —"Estados
   Unidos", "Reino Unido", "Alemania", "Japón"— y se dibujaban tal cual
   en las once interfaces que no lo son.

   La respuesta obvia era una tabla de 33 × 11 = 363 traducciones a
   mano. Sería la respuesta equivocada: **el navegador ya sabe los
   nombres de todos los países en todos los idiomas**, y los sabe mejor
   que nosotros. `Intl.DisplayNames` es la misma familia que este
   proyecto ya usa para fechas y meses, por el mismo motivo: 363 textos
   que mantener a mano son 363 oportunidades de equivocarse en un idioma
   que nadie en el equipo lee.

   ⚠️  TRES CÓDIGOS NO SON PAÍSES: `XN`, `XS` y `XT` son "otro
       hemisferio norte / sur / clima tropical". `Intl` no los conoce y
       devuelve el código tal cual —no lanza— así que se detecta ese
       caso y se cae a una clave de interfaz. Sin esa rama, el
       desplegable mostraría "XN".

   Si `Intl.DisplayNames` no existe o falla, se devuelve lo que mandó el
   servidor. Perder el idioma del país es molesto; perder la lista de
   países haría imposible elegir el hemisferio, que es de lo que depende
   la estación. */
export function pais(codigo, respaldo) {
  if (!codigo) return respaldo || "";
  if (codigo === "XN" || codigo === "XS" || codigo === "XT") {
    return t(`perfil.pais${codigo}`, respaldo || codigo);
  }
  try {
    const nombre = new Intl.DisplayNames([idiomaActual()], { type: "region" }).of(codigo);
    // Devuelve el código cuando no lo conoce: eso no es un nombre.
    return nombre && nombre !== codigo ? nombre : respaldo || codigo;
  } catch {
    return respaldo || codigo;
  }
}
